export default __webpack_public_path__ + "static/media/social_girl.3070ebb0.svg";